import { updateWireDepositAsync } from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSlice } from '../../../../createAsyncSlice';

export const { slice: updateWireDepositSlice, asyncAction: updateWireDepositAction } = createAsyncSlice(
  'updateWireDepositSlice',
  updateWireDepositAsync
);
